import { render, staticRenderFns } from "./agent-artifact-task-card.vue?vue&type=template&id=17b0f72b&scoped=true"
import script from "./agent-artifact-task-card.vue?vue&type=script&lang=js"
export * from "./agent-artifact-task-card.vue?vue&type=script&lang=js"
import style0 from "./agent-artifact-task-card.vue?vue&type=style&index=0&id=17b0f72b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0f72b",
  null
  
)

export default component.exports